<template>
	<tbody class="smart-tbody">
		<tr v-for="(row, id) in requestData" :class="loadStatus(row)">
			<td
				@click="clickInTd(col, row)"
				v-for="(col, index) in labels"
				:key="index"
				:class="GetClass(col)"
			>
				<span v-if="col.two == undefined">
					<i v-if="col.icon != undefined" :class="col.icon"></i>
					<span
						:title="strip_tags(text_processor(col.data, row))"
						:style="col.css != undefined ? col.css : ''"
						v-html="text_processor(col.data, row)"
						class="text"
					></span>
				</span>
				<span class="two-lines" v-else>
					<b
						:class="{
							iconed:
								col.icon != undefined &&
								(typeof col.icon == 'string' ||
									col.icon[0] != undefined),
						}"
					>
						<i
							v-if="
								col.icon != undefined &&
								typeof col.icon == 'string'
							"
							:class="col.icon"
						>
						</i>
						<i
							v-else-if="
								col.icon != undefined &&
								col.icon[0] != undefined
							"
							:class="col.icon[0]"
						>
						</i>
						<span
							:title="strip_tags(text_processor(col.data, row))"
							:style="col.css != undefined ? col.css : ''"
							v-html="text_processor(col.data[0], row)"
							class="text"
						>
						</span>
					</b>
					<small
						:class="{
							iconed:
								col.icon != undefined &&
								(typeof col.icon == 'string' ||
									col.icon[1] != undefined),
						}"
					>
						<i
							v-if="
								col.icon != undefined &&
								typeof col.icon == 'string'
							"
							:class="col.icon"
						>
						</i>
						<i
							v-else-if="
								col.icon != undefined &&
								col.icon[1] != undefined
							"
							:class="col.icon[1]"
						>
						</i>
						<span
							:title="strip_tags(text_processor(col.data, row))"
							:style="col.css != undefined ? col.css : ''"
							v-html="text_processor(col.data[1], row)"
							class="text"
						></span>
					</small>
				</span>
			</td>
			<table-actions
				:actions="actions"
				:row="row"
				@customAction="$emit('customAction', $event)"
			/>
		</tr>
	</tbody>
</template>
<script>
	import tableActions from './actions.vue';
	import moment from 'moment';
	export default {
		name: 'TableBody',
		props: [
			'labels',
			'requestData',
			'actions',
			'tags',
			'functions',
			'lineStatus',
			'actionsTmp',
		],
		components: { tableActions },
		methods: {
			GetClass(col) {
				let css = '';
				css = col.class != undefined ? col.class : ' ';
				css += col.event != undefined ? ' has-hover ' : '';
				return css;
			},
			clickInTd(col, row) {
				if (col.event != undefined) {
					this.$emit('customAction', {
						action: col.event,
						data: row,
					});
				}
			},
			loadStatus(row) {
				if (
					this.lineStatus != null &&
					this.lineStatus != undefined &&
					this.lineStatus != false
				) {
					try {
						return this.lineStatus(row);
					} catch (e) {}
				}
			},
			strip_tags(val) {
				return String(val).replace(/(<([^>]+)>)/gi, '');
			},

			tag_generation(tag) {
				let color = tag.color || 'primary';
				let html = tag.html || '...';
				let icon =
					tag.icon != undefined
						? `<i class='fa fa-${tag.icon}'></i>`
						: '';
				return `<span class='label label-${color}'>${icon} ${html}</span>`;
			},
			functions_processor(val, data, row) {
				if (this.functions == null) return val;
				else {
					let fx = this.functions.find((item) => item.cod == data);
					if (fx == undefined) return val;
					else {
						try {
							return fx.fx(val, row);
						} catch (e) {
							console.log(`ERROR [val: ${val}, data: ${data}]`);
							return 'Error:TableBody:104';
						}
					}
				}
			},
			get_obj_value(data, value) {
				let sData = data.split('.');
				let return_data = undefined;
				sData.forEach((item) => {
					if (typeof return_data == 'object') {
						if (return_data[item] != undefined)
							return_data = return_data[item];
					} else if (value != undefined) {
						if (typeof value[item] != undefined)
							return_data = value[item];
					}
				});
				return return_data;
			},
			text_processor(data, value) {
				const row = value;
				if (typeof data == 'string') {
					if (data.indexOf('.') == -1) {
						value = value[data];
						if (this.tags != null) {
							let tag = this.tags.find(
								(item) =>
									item.cod == data && item.value == value
							);
							if (tag == undefined)
								return this.functions_processor(
									value,
									data,
									row
								);
							else return this.tag_generation(tag);
						} else
							return this.functions_processor(value, data, row);
					} else {
						value = this.get_obj_value(data, value);
						const verifyDate = new Date(value);
						if (
							isNaN(value) &&
							verifyDate instanceof Date &&
							!isNaN(verifyDate)
						)
							return moment(value).format('DD/MM/YYYY HH:mm');

						if (this.tags != null) {
							let tag = this.tags.find(
								(item) =>
									item.cod == data && item.value == value
							);
							if (tag == undefined)
								return this.functions_processor(
									value,
									data,
									row
								);
							else return this.tag_generation(tag);
						} else
							return this.functions_processor(value, data, row);
					}
				} else {
					let rData = [];
					data.forEach((item) => {
						if (item.indexOf('.') == -1) {
							let nValue = value[item];
							if (this.tags != null) {
								let tag = this.tags.find(
									(item) =>
										item.cod == data && item.value == nValue
								);
								if (tag == undefined)
									rData.push(
										this.functions_processor(
											nValue,
											data,
											row
										)
									);
								else rData.push(this.tag_generation(tag));
							} else
								rData.push(
									this.functions_processor(nValue, data, row)
								);
						} else {
							rData.push(this.get_obj_value(item, value));
						}
					});
					value = rData.join(' ');
					data = data.join(',');
					if (this.tags != null) {
						let tag = this.tags.find(
							(item) => item.cod == data && item.value == value
						);
						if (tag == undefined)
							return this.functions_processor(value, data, row);
						else return this.tag_generation(tag);
					} else return this.functions_processor(value, data, row);
				}
			},
		},
		mounted() {
			// console.log(this.$slots)
		},
	};
</script>
<style scoped>
	.has-hover {
		cursor: pointer;
	}
</style>
<style>
	small.iconed span {
		margin-top: -2px;
	}
	.iconed span {
		width: calc(100% - 18px) !important;
		display: inline-block !important;
	}
	.iconed i {
		float: left;
	}
	.smart-tbody td {
		max-width: 300px;
	}
	.smart-tbody td .label {
		margin-right: 3px;
		margin-bottom: 3px;
		float: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
	.smart-tbody .text {
		display: block;
		font-size: 12px;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.smart-tbody .two-lines b {
		margin-top: -5px;
	}
	.smart-tbody .two-lines small {
		margin: -3px 0 -20px 0;
	}
	.smart-tbody .two-lines b span,
	.two-lines small span {
		width: 100%;
		overflow: hidden;
	}
	.smart-tbody .two-lines b,
	.two-lines small {
		display: block;
	}
	.smart-tbody .two-lines {
		margin: 2px 0 -9px 0;
		display: block;
		height: 33px;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/table/tbody.vue